import { gql } from "graphql-tag";

/**
 * Fetches teams using bookingId
 *
 * variable example
 * { "bookingId": "1820" }
 */
export const GET_Teams = gql`
  query GetTeams($bookingId: String!) {
    TeamOfParticipantsList(condition: { BookingId: { eq: $bookingId } }) {
      uuid: Uuid
      bookingId: BookingId
      name: Name
      roomPlayers: RoomPlayers
      startDateTime: StartDateTimeTz
      endDateTime: EndDateTimeTz
      nfcTag: NfcTag
      cancelled: Cancelled
      teamLevel: TeamLevel
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
